import { Trans, t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { ArrowLeft } from "lucide-react";

import { Asset } from "lib/bridge/types";

import { AssetCard } from "./AssetCard";

interface ScanCompletedScreenProps {
  assets: Asset[];
  onBack: () => void;
  onSelectAsset: (asset: Asset) => void;
}

export function ScanCompletedScreen({ assets, onBack, onSelectAsset }: ScanCompletedScreenProps) {
  useLingui();
  return (
    <div className="mt-[60px] flex flex-col  px-4 py-6 md:px-8 md:py-10">
      <div className="mx-auto flex w-full max-w-6xl">
        <button
          onClick={onBack}
          className="hover:bg-muted flex w-fit items-center gap-2 rounded-full bg-[#1E1E1F] px-10 py-6 text-[16px] text-[#ffff6] ring-1 ring-[#fff56] transition-colors hover:ring-[#FFF] md:text-[20px]"
          aria-label={t`Go back`}
        >
          <ArrowLeft />
          <Trans>Back</Trans>
        </button>
      </div>

      <div className="mx-auto my-6 flex w-full max-w-3xl flex-1 flex-col  md:my-10 md:gap-20">
        <h1 className="text-center text-24 font-bold md:text-40"><Trans>Scan completed</Trans></h1>
        <p className="mt-3 text-pretty text-center text-[14px] text-[#ffffff66] md:text-[16px]">
          <Trans>You have the following supported assets in your connected wallet.</Trans>
        </p>

        <div className="mt-8 flex w-full flex-col gap-10 md:mt-22">
          <p className="text-center text-[14px] font-medium text-[#fffff] md:text-[16px]"><Trans>Select an asset to proceed</Trans></p>
          {assets.map((asset, i) => (
            <AssetCard
              key={i}
              name={asset.name}
              balance={asset.balance}
              iconVariant={asset.iconVariant}
              tokenImage={asset.tokenImage}
              chainImage={asset.chainImage}
              onClick={() => onSelectAsset(asset)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
